import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  email: '',
  rights: {},
  roles: [],
  selectedRole: '',
  coreId: '',
  accessToken: ''
};

const loginSlice = createSlice({
  name: 'login',
  initialState,
  reducers: {
    setLogin: (state, action) => {
      state.email = action.payload.email;
      state.rights = action.payload.rights;
      state.roles = action.payload.roles;
      state.coreId = action.payload.coreId;
      state.selectedRole = action.payload.selectedRole;
      state.accessToken = action.payload.accessToken;
    },
    setSelectedRole: (state, action) => {
      state.selectedRole = action.payload;
    }
  },
});

export const { setLogin, setSelectedRole } = loginSlice.actions;

export default loginSlice.reducer;

